var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length
    ? _c("transition", [
        _c("div", { staticClass: "inline-links-menu" }, [
          _vm.isMobile
            ? _c(
                "div",
                { staticClass: "inline-links-menu--dropdown" },
                [
                  _c("dropdown", {
                    attrs: {
                      facets: ["inline-links-menu"],
                      "open-icon": _vm.DROPDOWN_ICONS.open,
                      "closed-icon": _vm.DROPDOWN_ICONS.closed,
                      label: _vm.title,
                      items: _vm.items
                    }
                  })
                ],
                1
              )
            : _c("nav", { staticClass: "inline-links-menu--content" }, [
                _c("h2", { staticClass: "inline-links-menu--title u-reset" }, [
                  _vm._v(
                    "\n                " + _vm._s(_vm.title) + "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "inline-links-menu--collection u-reset" },
                  _vm._l(_vm.items, function(item, index) {
                    return _c(
                      "li",
                      { key: index, staticClass: "inline-links-menu--item" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "inline-links-menu--link u-reset",
                            class: _vm.getMenuLinkClasses(item, index),
                            attrs: { href: item.path },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.scrollTo($event)
                              }
                            }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "inline-links-menu--text" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(item.label) +
                                    "\n                        "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "inline-links-menu--icon" },
                              [
                                item.isLockedContent
                                  ? _c("ui-icon", {
                                      attrs: {
                                        symbol: _vm.getLockSymbol(item),
                                        size: "small"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38aaf814", { render: render, staticRenderFns: staticRenderFns })
  }
}